// TODO: station
import { fromJS } from 'immutable';

import * as Constants from '../constants';
import { Map } from '../lib/ImmutableUtils';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [Constants.StationDetails.keys.SUGGESTIONS]: Map<$TSFixMe>(),
  [Constants.StationDetails.keys.STATION_ID]: '',
  [Constants.StationDetails.keys.LAUNCH_ADD_VARIETY]: false,
  [Constants.StationDetails.keys.VIDEO_ADS_DISABLED]: false,
});
export type StationDetailsState = typeof INITIAL_STATE;

// STATIONDETAILS REDUCER
export default createReducer(INITIAL_STATE, {
  [Constants.Api.ApiActions.GET_SEED_SUGGESTIONS_SUCCESS]: getSeedSuggestionsSuccess,
  [Constants.Api.ApiActions.GET_STATION_DETAILS_SUCCESS]: getStationDetailsSuccess,
  [Constants.StationDetails.actions.LAUNCH_ADD_VARIETY]: launchAddVariety,
  [Constants.StationDetails.actions.LEAVE_STATION_DETAILS]: leaveStationDetails,
  [Constants.StationDetails.actions.DISABLE_VIDEO_ADS_FOR_STATION]: disableVideoAdsForStation,
  [Constants.Playback.ActionTypes.SET_OR_CREATE_STATION_FINISHED]: enableVideoAdsForStation,
});

// CASE FUNCTIONS

function getSeedSuggestionsSuccess(
  state: StationDetailsState,
  action: $TSFixMe,
): StationDetailsState {
  return state.set(
    Constants.StationDetails.keys.SUGGESTIONS,
    fromJS(action.response.entities.artists || {}),
  );
}

function getStationDetailsSuccess(
  state: StationDetailsState,
  action: $TSFixMe,
): StationDetailsState {
  return state.set(Constants.StationDetails.keys.STATION_ID, fromJS(action.response.result));
}

function launchAddVariety(state: StationDetailsState): StationDetailsState {
  return state.set(Constants.StationDetails.keys.LAUNCH_ADD_VARIETY, true);
}

function leaveStationDetails(state: StationDetailsState): StationDetailsState {
  return state.set(Constants.StationDetails.keys.LAUNCH_ADD_VARIETY, false);
}

function disableVideoAdsForStation(state: StationDetailsState): StationDetailsState {
  return state.set(Constants.StationDetails.keys.VIDEO_ADS_DISABLED, true);
}

function enableVideoAdsForStation(state: StationDetailsState): StationDetailsState {
  return state.set(Constants.StationDetails.keys.VIDEO_ADS_DISABLED, false);
}
